import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

export default ({ isSubmitting, ...props }) => (
  <Submit type="submit" disabled={isSubmitting}>
    {props.children}
  </Submit>
)

export const submitButtonStyle = {
  padding: "0.8rem 3rem",
  margin: "2rem 0 0.5rem 0",
  fontSize: "0.8rem",
  color: "white",
  background: style.colors.primaryBlue,
  border: style.colors.darkerGray,
  borderRadius: 3,
  "&:hover": {
    cursor: "pointer",
    background: style.colors.darkerPrimaryBlue,
  },
}

const Submit = glamorous.button({
  ...submitButtonStyle,
})



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/SubmitButton/index.js